
export default {
  list: [],
  isUnique: true
}



// WEBPACK FOOTER //
// ./src/features/admin/contas/store/state.js